module.exports = __webpack_public_path__ + "img/abattage_2.b5f3560f.jpg";